import { useSessionCtx } from "../../context/SessionContext";
import { SECTIONS } from "../../constants/constants";

export function useSection() {
  const ctx = useSessionCtx();
  if (!ctx) return { compConfig: null, configLoading: true, saving: false, handleCompToggle: () => {}, resetComponents: () => {}, updateComponentConfig: () => {}, getVal: () => undefined, totalEnabled: 0, totalFields: 0, SECTIONS, isReady: false };
  const { compConfig, configLoading, saving, handleCompToggle, resetComponents, updateComponentConfig } = ctx;
  const getVal = (section, f) => (section.flat ? compConfig?.[f.key] : compConfig?.[section.key]?.[f.key]);
  const totalEnabled = compConfig ? SECTIONS.reduce((sum, s) => sum + s.fields.filter((f) => getVal(s, f)).length, 0) : 0;
  const totalFields = SECTIONS.reduce((sum, s) => sum + s.fields.length, 0);
  return { compConfig, configLoading, saving, handleCompToggle, resetComponents, updateComponentConfig, getVal, totalEnabled, totalFields, SECTIONS, isReady: true };
}
